import { jsx as _jsx } from "react/jsx-runtime";
import { useLinkComponent } from '#pplx/frontend/aether/components/link-component/useLinkComponent.js';
import classNames from 'classnames';
import { useCallback } from 'react';
export function LinkPrimitive({ ref, className, children, interactableVariant = 'default', onTrackEvent, __dangerousDoNotUseShouldApplyFocusIndicator = true, __dangerousDoNotUseOnClick, ...props }) {
    const LinkComponent = useLinkComponent();
    const handleClick = useCallback((event) => {
        __dangerousDoNotUseOnClick?.(event);
        onTrackEvent?.();
    }, [__dangerousDoNotUseOnClick, onTrackEvent]);
    return (_jsx(LinkComponent, { ...props, ref: ref, onClick: handleClick, className: classNames('reset', __dangerousDoNotUseShouldApplyFocusIndicator &&
            (interactableVariant === 'alt' ? 'interactable-alt' : 'interactable'), className), children: children }));
}
//# sourceMappingURL=index.js.map